export default function (formLink, isValid, localValue, onChangeCallback) {
    return formLink
        ? formLink.bind(props.fieldName, localValue.value, isValid.value)
        : onChangeCallback
}
